// Copy for the one notification switch in settings: whether this device receives pushes (an
// invitation, a settled request). App updates have no copy: they are silent (lib/updates.ts). One
// entry per locale, every key in all seven (nl is the source, the rest are translations).
export const updatesCopy = {
  nl: {
    "about.notify.switch": "Meldingen",
    "about.notify.switch.hint":
      "Een melding als iemand je uitnodigt of een aanvraag van jou is afgehandeld.",
  },
  en: {
    "about.notify.switch": "Notifications",
    "about.notify.switch.hint":
      "A notification when someone invites you or a request of yours is settled.",
  },
  de: {
    "about.notify.switch": "Benachrichtigungen",
    "about.notify.switch.hint":
      "Eine Benachrichtigung, wenn dich jemand einlädt oder eine Anfrage von dir erledigt ist.",
  },
  fr: {
    "about.notify.switch": "Notifications",
    "about.notify.switch.hint":
      "Une notification quand quelqu'un vous invite ou qu'une de vos demandes est traitée.",
  },
  es: {
    "about.notify.switch": "Notificaciones",
    "about.notify.switch.hint":
      "Un aviso cuando alguien te invita o se resuelve una solicitud tuya.",
  },
  it: {
    "about.notify.switch": "Notifiche",
    "about.notify.switch.hint":
      "Una notifica quando qualcuno ti invita o una tua richiesta è stata gestita.",
  },
  pt: {
    "about.notify.switch": "Notificações",
    "about.notify.switch.hint": "Um aviso quando alguém o convida ou um pedido seu é resolvido.",
  },
} as const;
